import React, { useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//Import Images
import avatar1 from "../../assets/images/users/user.png"
import { useEffect } from "react"
import { getTotalCustomerCounts } from "helpers/fakebackend_helper"
import { useQuery } from "react-query"

function CardUser(props) {
  const [settingsMenu, setSettingsMenu] = useState(false)
  //Setting Menu
  const toggleSettings = () => {
    setSettingsMenu(settingsMenu)
  }
  const [authUser, setAuthUser] = useState(null)

  useEffect(() => {
    // Get authUser from local storage
    const storedAuthUser = localStorage.getItem("authUser")
    if (storedAuthUser) {
      setAuthUser(JSON.parse(storedAuthUser))
    }
  }, [])

  const { data, isLoading } = useQuery('getTotalCustomerCounts', getTotalCustomerCounts, {
    staleTime: 120000,
      refetchOnWindowFocus: false,
    });

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <Row>
                <Col lg="4">
                  <div className="d-flex">
                    <div className="me-3">
                      <img
                        src={avatar1}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <p className="mb-2"> </p>
                        <h5 className="mb-1">{authUser?.name}</h5>
                        {/* <p className="mb-0">UI / UX Designer</p> */}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg="4" className="align-self-center">
                  <div className="text-lg-center mt-4 mt-lg-0">
                    <Row>
                      <Col xs="4">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Total Users
                          </p>
                          <h5 className="mb-0">{data?.total_users}</h5>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Total Customers
                          </p>
                          <h5 className="mb-0">{data?.total_parenting_spaces}</h5>
                        </div>
                      </Col>
                      <Col xs="4">
                        <div>
                          <p className="text-muted text-truncate mb-2">
                            Active Users
                          </p>
                          <h5 className="mb-0">--</h5>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>

                {/* <Col lg="4" className="d-none d-lg-block">
                  <div className="clearfix mt-4 mt-lg-0">
                    <Dropdown
                      isOpen={settingsMenu}
                      toggle={toggleSettings}
                      className="float-end"
                    >
                      <DropdownToggle tag="button" className="btn btn-primary">
                        <i className="bx bxs-cog align-middle me-1" /> Setting
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-end">
                        <DropdownItem href="#">Action</DropdownItem>
                        <DropdownItem href="#">Another action</DropdownItem>
                        <DropdownItem href="#">Something else</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </Col> */}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default CardUser
